<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" v-model="multiple" :label="$lang.multiple" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="headers" :label="$lang.headers" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="footers" :disabled="!multiple" :label="$lang.footers" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="disabled" :label="$lang.disabled" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="dense" :label="$lang.dense" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <transfer
          v-if="transfer"
          @input="onInput"
          ui-color="white"
          list-height="211px"
          footer-align="left"
          ref="transfer"
          :dense="dense"
          :disabled="disabled"
          :multiple="multiple"
          :ui-bg-color="$root.$colors.primary"
          :ui-bg-color-lightness="$root.$colors.bgColorLightness"
          :header-left="headers ? $lang.yourFavoriteGuitarists : null"
          :header-right="headers ? $lang.ourFavoriteGuitarists : null"
          :left="transfer.left"
          :right="transfer.right">
          <template v-slot:footer-left v-if="footers && multiple">
            <divider />
            <container :class="['px-2', 'pb-2']">
              <div v-html="$lang.transferFooterSlot()" :class="['px-2', 'pt-3', 'pb-2', 'text-xs']" />
              <divider :class="['mb-1']" />
              <checkbox :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="selectAllLeft" :label="$lang.selectAll" label-size="xs" />
            </container>
          </template>
          <template v-slot:footer-right v-if="footers && multiple">
            <divider />
            <container :class="['px-2', 'pb-2']">
              <div v-html="$lang.transferFooterSlot('right')" :class="['px-2', 'pt-3', 'pb-2', 'text-xs']" />
              <divider :class="['mb-1']" />
              <checkbox :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="selectAllRight" :label="$lang.selectAll" label-size="xs" />
            </container>
          </template>
        </transfer>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageTransfer',
  mixins: [
    methods
  ],
  data () {
    return {
      transfer: null,
      headers: true,
      footers: true,
      dense: false,
      disabled: false,
      multiple: true,
      selectAllLeft: false,
      selectAllRight: false
    }
  },
  watch: {
    selectAllLeft () {
      this.transfer.left.forEach(item => {
        item.selected = this.selectAllLeft
      })
    },
    selectAllRight () {
      this.transfer.right.forEach(item => {
        item.selected = this.selectAllRight
      })
    },
    multiple () {
      this.transfer = null
      this.footers = this.multiple
      this.$nextTick(() => {
        this.onMounted()
      })
    }
  },
  mounted () {
    this.onMounted()
  },
  methods: {
    onMounted () {
      this.getExternalData('transfer.json', 'transfer', 'GET', () => {
        this.ready = true
      })
    },
    onInput ($event) {
      this.log('input', 'transfer', $event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/transfer.vue